import { post, get, postJson  } from '../api/axios'

 const common = {
   async decrypt( p = '',url='public/decrypt',type = 'get') {
    //  console.log(type);
     if (type == 'get') {
     return  await get(url, p)
    } else {
      return await postJson(url, p)
    }
   },
}

export default common